import { Box, Button, ButtonGroup, Stack } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { ReactComponent as Logo } from '../../../assets/svgs/logo.svg';
import PreviewButtons from '../buttons/PreviewButtons';

function MinimoPreview({ leatherColors, threadColors, resetColors, getEffectiveColor, stitchColor, engraving, generateShareUrl }) {
    const [currentSide, setCurrentSide] = useState('front'); // 'front' or 'back'
    const [filename, setFilename] = useState('');

    const shareDescription = 'Check out my custom Minimo Wallet design!';

    useEffect(() => {
        const baseColor = leatherColors?.find(c => c.id === getEffectiveColor('base'))?.name;
        const threadColor = threadColors?.find(c => c.hex === stitchColor)?.name;
        const newfilename = `${baseColor}-${threadColor}-${currentSide}`;
        setFilename(newfilename);
    }, [leatherColors, threadColors, getEffectiveColor, currentSide, stitchColor]);

    const svgRef = useRef(null);

    const toggleView = (side) => {
        setCurrentSide(side);
    };

    return (
        <Stack
            sx={{
                width: { lg: '70%', md: '85%', sm: '100%' },
                margin: 'auto',
                bgcolor: 'background.paper',
                overflow: 'hidden',
                direction: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 3
            }}
        >
            <ButtonGroup variant="contained" sx={{ mt: 1 }}>
                <Button
                    onClick={() => toggleView('front')}
                    color={currentSide === 'front' ? 'primary' : 'default'}
                >
                    Front
                </Button>
                <Button
                    onClick={() => toggleView('back')}
                    color={currentSide === 'back' ? 'primary' : 'default'}
                >
                    Back
                </Button>
            </ButtonGroup>

            <Box width="100%" height="auto" sx={{ mt: 2 }}>
                <svg viewBox="0 0 76.703 98.529" ref={svgRef} style={{ stroke: '#000', strokeWidth: 0.25 }}>

                    <defs>
                        <clipPath id="wallet-front-base">
                            <path transform="translate(-308.854 -99.477)" d="m326.888 99.61-.021.001c-3.065.324-7.414 1.46-10.726 5.029-2.225 2.396-4.561 3.683-6.757 3.72-.07-.002-.125-.012-.193-.013v85.48c.078-.011.145-.056.226-.056.58 0 1.11.283 1.434.761.67 3.56 5.914 3.121 11.833 3.121h44c5.92 0 11.27.62 11.832-3.12v-.006a4.002 4.002 0 0 1 2.566-.902c.962 0 1.87.32 2.578.907l.084.109c.094.396.255.717.435 1.018v-94.318c-3.998-.954-7.44-1.732-11.756-1.732h-43.817z" />
                        </clipPath>
                        <clipPath id="wallet-front-flap">
                            <path transform="translate(-308.854 -99.477)" d="M308.986 119.813v73.94c.583.13 1.16.379 1.7.856 1.794 4.082 5.948 3.179 11.859 3.179h56.374c.57 0 6.505-.04 6.505-5.121V143.85c0-4.199-5.254-5.461-5.254-5.461-22.914-6.253-46.749-12.322-71.184-18.576z" />
                        </clipPath>
                        <clipPath id="wallet-back-base">
                            <path transform="matrix(-1 0 0 1 384.311 -99.477)" d="M372.423 99.61c4.316 0 7.758.777 11.756 1.73v92.28l-.52.912a4.022 4.022 0 0 0-2.577-.907c-.959 0-1.863.319-2.566.902v.005c-.562 3.74-5.913 3.121-11.832 3.121h-44c-5.92 0-11.162.439-11.833-3.121a1.722 1.722 0 0 0-1.434-.761c-.08 0-.148.044-.226.055v-85.48c.068.002.123.012.193.013 2.196-.037 4.532-1.323 6.757-3.72 3.311-3.568 7.66-4.704 10.725-5.028l.021-.002H340.161z" />
                        </clipPath>
                        <clipPath id="wallet-back-inner">
                            <path transform="translate(-131.388 -211.867)" d="M190.42 217.854c-12.497.205-17.758 3.042-30.062 7.943l-9.847 3.922c-5.182 2.063-4.58 5.594-4.58 5.594l-.202 66.292c.082 8.364-.123 8.434 4.892 8.438l44 .038c5.919.005 11.09.63 11.835-3.11v-.016a1.723 1.723 0 0 1 1.425-.745l.005.001v-85.415c-2.175-.039-3.61-.12-6.721-1.077-4.553-1.63-7.66-1.536-10.725-1.863z" />
                        </clipPath>
                        <clipPath id="wallet-back-thumb">
                            <path transform="matrix(-1 0 0 1 208.018 -211.338)" d="M207.886 212.957v91.868c-.104.668-.248 1.561-.248 1.561-.502 1.447-3.335 3.829-6.03 3.829h-55.133c-.613.005-1.281.007-1.84 0h-6.632a6.335 6.335 0 0 1-5.596-3.34c-.087.066-.797-1.27-.882-1.195a.04.04 0 0 0-.005.01v-72.864c22.951-5.893 46.459-11.95 70.34-18.51 2.204-.528 4.11-.977 6.026-1.36zm-32.136 37.515-12.15.01a5.291 5.291 0 0 0-5.234 6.031l3.118 22.076a7 7 0 0 0 6.936 6.02l2.446-.002a7.024 7.024 0 0 0 6.947-6.03l3.16-22.086a5.272 5.272 0 0 0-5.223-6.02z" />
                        </clipPath>
                    </defs>

                    {currentSide === 'front' && (
                        <g style={{ fill: 'none' }}>
                            <g>
                                <g clipPath="url(#wallet-front-base)">
                                    <image
                                        href={leatherColors?.find(c => c.id === getEffectiveColor(`base`))?.texture}
                                        x="0"
                                        y="0"
                                        width="100%"
                                        height="100%"
                                        preserveAspectRatio="xMidYMid slice"
                                    />
                                </g>
                                <path transform="translate(-308.854 -99.477)" d="m326.888 99.61-.021.001c-3.065.324-7.414 1.46-10.726 5.029-2.225 2.396-4.561 3.683-6.757 3.72-.07-.002-.125-.012-.193-.013v85.48c.078-.011.145-.056.226-.056.58 0 1.11.283 1.434.761.67 3.56 5.914 3.121 11.833 3.121h44c5.92 0 11.27.62 11.832-3.12v-.006a4.002 4.002 0 0 1 2.566-.902c.962 0 1.87.32 2.578.907l.084.109c.094.396.255.717.435 1.018v-94.318c-3.998-.954-7.44-1.732-11.756-1.732h-43.817z" />
                                <g clipPath="url(#wallet-front-flap)">
                                    <image
                                        href={leatherColors?.find(c => c.id === getEffectiveColor(`base`))?.texture}
                                        x="0"
                                        y="0"
                                        width="100%"
                                        height="100%"
                                        preserveAspectRatio="xMidYMid slice"
                                    />
                                </g>
                                <path transform="translate(-308.854 -99.477)" d="M308.986 119.813v73.94c.583.13 1.16.379 1.7.856 1.794 4.082 5.948 3.179 11.859 3.179h56.374c.57 0 6.505-.04 6.505-5.121V143.85c0-4.199-5.254-5.461-5.254-5.461-22.914-6.253-46.749-12.322-71.184-18.576z" />
                            </g>

                            <path id="stitchline" style={{ stroke: stitchColor, strokeWidth: '.8', strokeDasharray: '2,2', strokeDashoffset: 0 }} d="m460.907 576.261 61.662.034" transform="translate(-453.072 -482.215)" />

                            {engraving && (
                                <g stroke="#000" strokeWidth={0.25} fill="#000" opacity={0.8}>
                                    <text fontFamily="EB Garamond" fontSize={12} x={70} y={85} textAnchor="end">
                                        {engraving}
                                    </text>
                                </g>
                            )}

                            {!engraving && (
                                <g fill="#000" strokeWidth={0} opacity={0.75} transform='translate(50 66)' >
                                    <Logo height="20px" width="18px" />
                                </g>
                            )}
                        </g>
                    )}

                    {currentSide === 'back' && (
                        <g style={{ fill: 'none' }}>
                            <g clipPath="url(#wallet-back-base)">
                                <image
                                    href={leatherColors?.find(c => c.id === getEffectiveColor(`base`))?.texture}
                                    x="0"
                                    y="0"
                                    width="100%"
                                    height="100%"
                                    preserveAspectRatio="xMidYMid slice"
                                />
                            </g>
                            <path transform="matrix(-1 0 0 1 384.311 -99.477)" d="M372.423 99.61c4.316 0 7.758.777 11.756 1.73v92.28l-.52.912a4.022 4.022 0 0 0-2.577-.907c-.959 0-1.863.319-2.566.902v.005c-.562 3.74-5.913 3.121-11.832 3.121h-44c-5.92 0-11.162.439-11.833-3.121a1.722 1.722 0 0 0-1.434-.761c-.08 0-.148.044-.226.055v-85.48c.068.002.123.012.193.013 2.196-.037 4.532-1.323 6.757-3.72 3.311-3.568 7.66-4.704 10.725-5.028l.021-.002H340.161z" />
                            <g clipPath="url(#wallet-back-inner)">
                                <image
                                    href={leatherColors?.find(c => c.id === getEffectiveColor(`base`))?.texture}
                                    x="0"
                                    y="0"
                                    width="100%"
                                    height="100%"
                                    preserveAspectRatio="xMidYMid slice"
                                />
                            </g>
                            <path transform="translate(-131.388 -211.867)" d="M190.42 217.854c-12.497.205-17.758 3.042-30.062 7.943l-9.847 3.922c-5.182 2.063-4.58 5.594-4.58 5.594l-.202 66.292c.082 8.364-.123 8.434 4.892 8.438l44 .038c5.919.005 11.09.63 11.835-3.11v-.016a1.723 1.723 0 0 1 1.425-.745l.005.001v-85.415c-2.175-.039-3.61-.12-6.721-1.077-4.553-1.63-7.66-1.536-10.725-1.863z" />
                            <g clipPath="url(#wallet-back-thumb)">
                                <image
                                    href={leatherColors?.find(c => c.id === getEffectiveColor(`base`))?.texture}
                                    x="0"
                                    y="0"
                                    width="100%"
                                    height="100%"
                                    preserveAspectRatio="xMidYMid slice"
                                />
                            </g>
                            <path transform="matrix(-1 0 0 1 208.018 -211.338)" d="M207.886 212.957v91.868c-.104.668-.248 1.561-.248 1.561-.502 1.447-3.335 3.829-6.03 3.829h-55.133c-.613.005-1.281.007-1.84 0h-6.632a6.335 6.335 0 0 1-5.596-3.34c-.087.066-.797-1.27-.882-1.195a.04.04 0 0 0-.005.01v-72.864c22.951-5.893 46.459-11.95 70.34-18.51 2.204-.528 4.11-.977 6.026-1.36zm-32.136 37.515-12.15.01a5.291 5.291 0 0 0-5.234 6.031l3.118 22.076a7 7 0 0 0 6.936 6.02l2.446-.002a7.024 7.024 0 0 0 6.947-6.03l3.16-22.086a5.272 5.272 0 0 0-5.223-6.02z" />

                            <path id="stitchline" style={{ stroke: stitchColor, strokeWidth: '.8', strokeDasharray: '2,2', strokeDashoffset: 0 }} d="m460.907 576.261 61.662.034" transform="translate(-453.072 -482.215)" />

                            {/* {engraving && (
                                <g stroke="#000" strokeWidth={0.25} fill="#000" opacity={0.8}>
                                    <text fontFamily="EB Garamond" fontSize={12} x={'50%'} y={32} textAnchor="middle">
                                        {engraving}
                                    </text>
                                </g>
                            )} */}
                        </g>
                    )}
                </svg>
            </Box>

            <PreviewButtons
                resetColors={resetColors}
                shareDescription={shareDescription}
                generateShareUrl={generateShareUrl}
                svgRef={svgRef}
                filename={filename}
            />
        </Stack >
    );
}

MinimoPreview.propTypes = {
    leatherColors: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        swatch: PropTypes.string.isRequired,
        texture: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired
    })).isRequired,
    threadColors: PropTypes.arrayOf(PropTypes.shape({
        hex: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired
    })).isRequired,
    getEffectiveColor: PropTypes.func.isRequired,
    resetColors: PropTypes.func.isRequired,
    stitchColor: PropTypes.string.isRequired,
    engraving: PropTypes.string,
    generateShareUrl: PropTypes.func.isRequired
};

export default MinimoPreview; 